<template lang="pug">
  v-row
    v-chip-group(
      column
    )
      draggable.justify-center(
        v-model="cards"
        :disabled="readonly"
        :component-data="{props}"
      )
        v-chip(
          v-for="(chip, idx) in cards"
          :key="idx"
          color="secondary"
          :href="chip.url"
          target="_blank"
          :close="!readonly"
          @click:close="removeCard(idx)"
        ) {{ chip.title }}
        tooltip-wrap(text="Добавить ссылку")
          v-chip(
            v-if="!readonly"
            color="primary" outlined
            @click="addLink"
          )
            v-icon mdi-plus

</template>

<script>
import ConstructorCard from '@/models/list/ConstructorCard';
import draggable from 'vuedraggable';
import CAddLink from './СAddLink.vue';
import { CARD_TYPES } from './constants';

export default {
  components: {
    draggable,
  },
  props: {
    // Array of Cards
    cardsValues: { type: Array, default: null },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      props: {
        group: true,
        'leave-absolute': true,
      },
    };
  },
  computed: {
    cards: {
      get() {
        return this.cardsValues;
      },
      set(value) {
        this.$emit('update:cards', value);
      },
    },
  },
  methods: {
    addLink() {
      this.$modals.show('generic-controller', {
        title: 'Добавить ссылку',
        component: CAddLink,
        'component-props': {
          type: CARD_TYPES.link,
          success: (link) => {
            this.cards.push(new ConstructorCard(link));
            this.$modals.close();
          },
        },
      });
    },
    editLink(positionIdx, item) {
      this.$modals.show('generic-controller', {
        title: 'Редактировать ссылку',
        component: CAddLink,
        'component-props': {
          value: item,
          type: CARD_TYPES.link,
          success: (link) => {
            this.cards.splice(positionIdx, 1, link);
            this.$modals.close();
          },
        },
      });
    },
    removeCard(positionIdx) {
      this.cards.splice(positionIdx, 1);
    },
  },
};
</script>
